import { PageContainer } from '../../components/Layout/PageContainer'
import { PageTitle } from '../../components/PageTitle'

import React from 'react'
import { UserInfo } from './UserInfo/UserInfo'

export const Profile: React.VFC = () => {
    return (
        <PageContainer>
            <PageTitle>Your Profile</PageTitle>
            <UserInfo />
        </PageContainer>
    )
}
